<template>
  <div class="dashboard">
    <div class="sidebar">
      <div class="logo">水质检测管理系统</div>
      <el-menu
          :default-active="$route.fullPath"
          :default-openeds="openedSubmenus"
          class="el-menu-vertical-demo"
          router
      >
        <el-menu-item index="/home">
          <el-icon><i class="el-icon-house"></i></el-icon>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item v-if="permission !== 2" index="/inspector-management">
          <el-icon><i class="el-icon-s-custom"></i></el-icon>
          <span slot="title">检测员管理</span>
        </el-menu-item>
        <el-menu-item index="/user-management">
          <el-icon><i class="el-icon-user"></i></el-icon>
          <span slot="title">客户管理</span>
        </el-menu-item>
        <el-menu-item index="/water-quality-data">
          <el-icon><i class="el-icon-data-analysis"></i></el-icon>
          <span slot="title">水质数据管理</span>
        </el-menu-item>
        <el-menu-item v-if="permission === 0" index="/device-log-query">
          <el-icon><i class="el-icon-menu"></i></el-icon>
          <span slot="title">日志查询</span>
        </el-menu-item>
        <el-menu-item index="/detection-management">
          <el-icon><i class="el-icon-search"></i></el-icon>
          <span slot="title">检测管理</span>
        </el-menu-item>
        <el-sub-menu v-if="permission === 0" index="reagent-group" class="reagent-submenu">
          <template #title>
            <el-icon><i class="el-icon-box"></i></el-icon>
            <span>试剂防伪管理</span>
          </template>
          <el-menu-item index="/reagent-management">试剂管理</el-menu-item>
          <el-menu-item index="/reagent-management?tab=record">出库记录</el-menu-item>
          <el-menu-item index="/reagent-management?tab=out">出库管理</el-menu-item>
          <el-menu-item index="/reagent-monitor/account">试剂使用监控</el-menu-item>
          <el-menu-item index="/reagent-monitor/device">设备检测统计</el-menu-item>
          <el-menu-item index="/reagent-monitor/warning">异常预警中心</el-menu-item>
          <el-menu-item index="/reagent-monitor/config">系统配置</el-menu-item>
        </el-sub-menu>
        <el-sub-menu v-if="permission === 0" index="mall-group">
          <template #title>
            <el-icon><i class="el-icon-shopping-cart-full"></i></el-icon>
            <span>商城管理</span>
          </template>
          <el-menu-item index="/mall/products">商品管理</el-menu-item>
          <el-menu-item index="/mall/orders">订单管理</el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>

    <div class="main-wrapper">
      <div class="header">
        <h3>水质检测管理系统</h3>
        <el-button type="primary" class="logout-button" @click="logout">退出登录</el-button>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {
      permission: null,
    };
  },
  computed: {
    openedSubmenus() {
      const path = this.$route.path;
      const opened = [];
        if (path.startsWith('/reagent-management') || path.startsWith('/reagent-monitor')) {
          opened.push('reagent-group');
        }
        if (path.startsWith('/detection-management')) {
          // no submenu to open, but keep pattern consistent
        }
        if (path.startsWith('/mall')) {
        opened.push('mall-group');
      }
      return opened;
    },
  },
  created() {
    const permStr = localStorage.getItem("permission");
    console.log('Dashboard created, raw permission from localStorage =', permStr);
    if (permStr !== null && permStr !== undefined) {
      this.permission = Number(permStr);
      console.log('Normalized permission (Number) =', this.permission);
      return;
    }
    this.$router.push("/login");
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("permission");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.dashboard {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.sidebar {
  width: 240px;
  background-color: #2d3a4b;
  color: #ffffff;
  flex-shrink: 0;
  overflow-y: auto;
  padding-top: 20px;
}

.logo {
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
}

.el-menu-vertical-demo {
  background-color: #2d3a4b;
  color: #ffffff;
}

.el-menu-item,
.el-sub-menu__title {
  color: #ffffff;
  font-size: 16px;
}

.el-menu-item:hover,
.el-sub-menu__title:hover {
  background-color: #1f2a38;
}

:deep(.el-sub-menu__title) {
  color: #ffffff;
  font-size: 16px;
  padding-left: 20px !important;
}

:deep(.reagent-submenu > .el-sub-menu__title) {
  padding-left: 20px !important;
}

:deep(.el-sub-menu .el-menu-item) {
  background-color: #1f2a38;
  color: #c8d3df;
  font-size: 14px;
  padding-left: 70px !important;
}

:deep(.el-sub-menu .el-menu-item:hover) {
  background-color: #263445;
}

:deep(.el-sub-menu .el-menu-item.is-active) {
  background-color: #4a85de;
  color: #ffffff;
}

/* 试剂管理一级标题：去掉悬浮高亮 */
:deep(.reagent-submenu > .el-sub-menu__title:hover) {
  background-color: transparent !important;
}

/* 试剂管理一级标题：展开时（有子项选中）显示激活色 */
:deep(.reagent-submenu.is-opened > .el-sub-menu__title) {
  color: #4a85de !important;
  font-weight: bold;
}

.el-menu-item.is-active {
  background-color: #4a85de;
  color: #ffffff;
}

.main-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  background-color: #ffffff;
  padding: 16px 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 20px;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.content {
  flex: 1;
  background-color: #f9f9f9;
  padding: 24px;
  overflow-y: auto;
}

h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
}
</style>
